import { useMutation } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const UPDATE_SPEC = gql`
  mutation UpdateSpec($input: UpdateProductSpecificationInput!) {
    updateProductSpecification(input: $input) {
      id
    }
  }
`;

export default function useUpdateSpec() {
  return useMutation(UPDATE_SPEC);
}
